import React, { useCallback, useEffect, useRef, useState, useContext } from 'react';
import { MainContext } from '../../Context/MainContext';
import Modal from '../Templates/ModalsTemplates/Modal';
import Tabela01 from '../Templates/Tabela01';
import { useForm } from 'react-hook-form';
import axios from 'axios';

const urlServidor = process.env.REACT_APP_SERVIDOR;
let user;

function MudarProjeto({ setNewProjeto, filtro, filtroCd }){

    const { setStatus } = useContext(MainContext);
    const [projetos, setProjetos] = useState([]);
    const closeBtn = useRef(null);
    const cdBtn = useRef(null);

    useEffect(() => {
        user = JSON.parse(sessionStorage.getItem('user'));
        axios.post(`${urlServidor}/Userprojetos`, {'cpf':`${user.cpf}`,'busca':'','pagina':0,'qtd_reg':''})
            .then(resp => setProjetos(resp.data.projetos))
            .catch(error => console.log(error));
    }, []);

    const handleRowClick = useCallback((e) => {
        axios.post(`${urlServidor}/Usercds`, {'cod_usuario': `${e.data.usuario}`, 'busca': '', 'pagina': 0, 'qtd_reg': ''})
            .then(resp => {
                if(resp.data.qtd_cds !== 1){
                    setNewProjeto(e.data);
                    cdBtn.current.click();
                    setTimeout(() => {
                        filtroCd.setFocus('filtro');
                    }, 500);
                }
                else{
                    const user = sessionStorage.getItem('user');
                    sessionStorage.clear();
                    sessionStorage.setItem('user', user);
                    sessionStorage.setItem('qtd_cds', JSON.stringify(resp.data.qtd_cds));
                    sessionStorage.setItem('cd', JSON.stringify(resp.data.cds[0]));
                    sessionStorage.setItem('projeto', JSON.stringify(e.data));
                    sessionStorage.setItem('token', e.data.token_jwt_web || resp.data.cds[0].token_jwt_web);
                    window.location.replace('/inicio');
                }
                closeBtn.current.click();
            })
            .catch(() => setStatus('Você não possui acesso a nenhum CD nesse projeto!'));
    }, []);

    const handleKeyDown = useCallback((e) => {
        if(e.key === 'Enter'){
            const tableData = projetos.filter(projeto => String(projeto.projeto).includes(filtro.watch('filtro')) || projeto.nome_projeto.includes(filtro.watch('filtro')));
                if(tableData.length){
                    handleRowClick({ data: tableData[0] });
                }
            }
    }, [projetos, handleRowClick]);

    const Content = useCallback(() => (
        <>
            <div className="pesquisa d-flex align-items-baseline mb-2">
                <p className='m-0'>Filtro: </p>
                <input className='form-control form-control-sm ms-1' type="text" placeholder="Digite o nome ou o código do seu projeto" {...filtro.register('filtro', { onChange: e => filtro.setValue('filtro', e.target.value.toUpperCase()) })} autoComplete='off' onKeyDown={handleKeyDown} />
            </div>
            <Tabela01 columns={[
                { datafield: 'projeto', caption: 'ID', width: 80, defaultSortOrder: 'asc' },
                { datafield: 'nome_projeto', caption: 'Nome' }
            ]} 
            data={projetos.filter(projeto => String(projeto.projeto).includes(filtro.watch('filtro')) || projeto.nome_projeto.includes(filtro.watch('filtro')))}
            onRowClick={handleRowClick} 
            disableHeaderFilter 
            disableSearchPanel
            height='370'
            />
            <button ref={closeBtn} className="d-none" data-bs-dismiss="modal"></button>
            <button ref={cdBtn} className="d-none" data-bs-toggle="modal" data-bs-target="#mudar-cd-modal"></button>
        </>
    ), [handleRowClick, projetos]);

    return(
        <Modal size='lg' content={<Content />} id="mudar-projeto-modal" title="Mudar Projeto" ></Modal>
    );
}

export default MudarProjeto;